import { getDocumentToken } from "../APIEndPoints/EndPoints";
import { decryptV2, encryptV2 } from "../Cryptography/CryptoV2";
import { APICall } from "../Network/APICalls";

export const downloadBlob = async (url) => {
  const SASTokenTime = decryptV2(localStorage.getItem("SASTokenTime"));
  const SASToken = decryptV2(localStorage.getItem("SASToken"));

  if (new Date() < new Date(SASTokenTime)) {
    return `${url}${SASToken}`;
  } else {
    await saveSASToken();
    const SASTokenNew = decryptV2(localStorage.getItem("SASToken"));
    return `${url}${SASTokenNew}`;
  }
};

let isFetchingSASToken = false;
const saveSASToken = async () => {
  let sasTokenResolve;
  let sasTokenReject;
  try {
    const sasTokenPromise = new Promise((resolve, reject) => {
      sasTokenResolve = resolve;
      sasTokenReject = reject;
    });

    if (!isFetchingSASToken) {
      isFetchingSASToken = true;

      const data = await APICall(getDocumentToken, null);

      if (!(typeof data?.Data == "string")) {
        return false;
      }
      localStorage.setItem("SASToken", encryptV2(data?.Data));
      const time = new Date();

      const mins = time.getMinutes();

      time.setMinutes(mins + 2);
      localStorage.setItem("SASTokenTime", encryptV2(time.toString()));
      sasTokenResolve();
    } else {
      await sasTokenPromise;
    }

    return true;
  } catch (err) {
    sasTokenReject();
    return false;
  } finally {
    isFetchingSASToken = false;
  }
};
